import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { useAnimation } from '../../contexts/AnimationContext';

const PageTransition = ({ children }) => {
  const location = useLocation();
  const { getPageTransitionVariants, animationSettings } = useAnimation();

  const variants = getPageTransitionVariants();

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={location.pathname}
        initial="initial"
        animate="animate"
        exit="exit"
        variants={variants}
        className="w-full"
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default PageTransition;